import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ItemMasterHelp from "../../../Helper/SystemmasterHelp";
import SystemHelpMaster from "../../../Helper/SystemmasterHelp";
import '../Ledger/Ledger.css';
import { TextField, Grid, Typography, Paper, Box } from '@mui/material';
import ReportButton from "../../../Common/Buttons/ReportButton"
import { CgArrowTopRightR } from "react-icons/cg";

const StockBookDetail = () => {
  const today = new Date().toISOString().split("T")[0];
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [itemCode, setItemCode] = useState("");
  const [item_Name, setItemName] = useState("");
  const [accoid, setAccoid] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)
  const [newGodownCode, setnewGodownCode] = useState("");
  const [lblGodownName, setlblGodownName] = useState("");

  const AccountYear = sessionStorage.getItem('Accounting_Year');

  useEffect(() => {
          if (AccountYear) {
              const dates = AccountYear.split(' - ');
              if (dates.length === 2) {
                  setFromDate(dates[0]);
                  setToDate(dates[1]);
              }
          }
      }, [AccountYear]);

  const handleItemCode = (code, accoid, hsn, name) => {
    setItemCode(code);
    setItemName(name);
    setAccoid(accoid);
  };

  const handleGoDown = (code, accoid, name) => {
    setnewGodownCode(code);
    setlblGodownName(name);

  };
  const handleStockBookReport = (e) => {
    setLoading(true);
    setTimeout(() => {
      const url = `/stock-book-report?fromDate=${encodeURIComponent(fromDate)}&toDate=${encodeURIComponent(toDate)}&itemCode=${encodeURIComponent(itemCode)}&godawnCode=${encodeURIComponent(newGodownCode)}`;
      window.open(url, '_blank', 'toolbar=yes,location=yes,status=yes,menubar=yes,scrollbars=yes,resizable=yes,width=800,height=600');
      setLoading(false);
    }, 500);
  };

  const handleStockBookReportSB = (e) => {
    setLoading(true);
    setTimeout(() => {
      const url = `/stock-book-reportSB?fromDate=${encodeURIComponent(fromDate)}&toDate=${encodeURIComponent(toDate)}&itemCode=${encodeURIComponent(itemCode)}&godawnCode=${encodeURIComponent(newGodownCode)}`;
      window.open(url, '_blank', 'toolbar=yes,location=yes,status=yes,menubar=yes,scrollbars=yes,resizable=yes,width=800,height=600');
      setLoading(false);
    }, 500);
  };



  const handleStockBookMillwiseReport = (e) => {
    setLoading(true);
    setTimeout(() => {
      const url = `/stock-book-report-millwise?fromDate=${encodeURIComponent(fromDate)}&toDate=${encodeURIComponent(toDate)}&itemCode=${encodeURIComponent(itemCode)}&godawnCode=${encodeURIComponent(newGodownCode)}`;
      window.open(url, '_blank', 'toolbar=yes,location=yes,status=yes,menubar=yes,scrollbars=yes,resizable=yes,width=800,height=600');
      setLoading(false);
    }, 500);
  };


  const handleStockBookDetailReport = (e) => {
    setLoading(true);
    setTimeout(() => {
      const url = `/stock-book-detail-report?fromDate=${encodeURIComponent(fromDate)}&toDate=${encodeURIComponent(toDate)}&itemCode=${encodeURIComponent(itemCode)}&godawnCode=${encodeURIComponent(newGodownCode)}`;
      window.open(url, '_blank', 'toolbar=yes,location=yes,status=yes,menubar=yes,scrollbars=yes,resizable=yes,width=800,height=600');
      setLoading(false);
    }, 500);
  };

  const handleStockBookDetailReportSB = (e) => {
    setLoading(true);
    setTimeout(() => {
      const url = `/stock-book-detail-reportSB?fromDate=${encodeURIComponent(fromDate)}&toDate=${encodeURIComponent(toDate)}&itemCode=${encodeURIComponent(itemCode)}&godawnCode=${encodeURIComponent(newGodownCode)}`;
      window.open(url, '_blank', 'toolbar=yes,location=yes,status=yes,menubar=yes,scrollbars=yes,resizable=yes,width=800,height=600');
      setLoading(false);
    }, 500);
  };

  // const handleRetailDetailReport = (e) => {
  //   navigate(`/retail-stock-book-detail-report`, {
  //     state: { itemCode, fromDate, toDate, item_Name },
  //   });
  // };

  return (
    <>
      <Typography
        variant="h5"
        sx={{
          textAlign: "center",
          fontWeight: "bold",
          mt: 4,
          mb: 4,
        }}
      >
        FNO Purchase And Sale Details Report
      </Typography>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "20px",
        }}
      >
        <Paper
          elevation={3}
          sx={{
            width: "100%",
            maxWidth: "1500px",
            padding: 4,
            borderRadius: "12px",
          }}
        >
          <form onSubmit={handleStockBookReport}>
            <Grid container spacing={3} alignItems="center">

              {/* Item Code */}
              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    width: "100%",
                  }}
                >
                  <Typography
                    sx={{
                      minWidth: "100px",
                      fontWeight: 600,
                      fontSize: "14px",
                    }}
                  >
                    Item Code :
                  </Typography>

                  <Box sx={{ flex: 1 }}>
                    <ItemMasterHelp
                      onAcCodeClick={handleItemCode}
                      CategoryName={item_Name}
                      CategoryCode={itemCode}
                      SystemType="I"
                      name="item_code"
                      className="account-master-help"
                    />
                  </Box>
                </Box>
              </Grid>
              {/* Godown Code */}
              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    width: "100%",
                  }}
                >
                  <Typography
                    sx={{
                      minWidth: "120px",
                      fontWeight: 600,
                      fontSize: "14px",
                    }}
                  >
                    Godown Code :
                  </Typography>

                  <Box sx={{ flex: 1 }}>
                    <SystemHelpMaster
                      onAcCodeClick={handleGoDown}
                      CategoryName={lblGodownName}
                      CategoryCode={newGodownCode}
                      name="godownCode"
                      SystemType="W"
                    />
                  </Box>
                </Box>
              </Grid>

              {/* From Date */}
              <Grid item xs={12} md={2}>
                <TextField
                  label="From Date"
                  type="date"
                  name="fromDate"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  fullWidth
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>

              {/* To Date */}
              <Grid item xs={12} md={2}>
                <TextField
                  label="To Date"
                  type="date"
                  name="toDate"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  fullWidth
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            </Grid>

            {/* Buttons */}
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 2,
                justifyContent: "center",
                mt: 4,
              }}
            >
              <ReportButton
                label="Stock Book Report"
                icon={CgArrowTopRightR}
                onClick={handleStockBookReport}
                loading={loading}
              />

              <ReportButton
                label="Millwise Stock Report"
                icon={CgArrowTopRightR}
                onClick={handleStockBookMillwiseReport}
                loading={loading}
              />

              <ReportButton
                label="Stock Book Detail"
                icon={CgArrowTopRightR}
                onClick={handleStockBookDetailReport}
              />

              <ReportButton
                label="Stock Book Report For SB"
                icon={CgArrowTopRightR}
                onClick={handleStockBookReportSB}
                loading={loading}
              />

              <ReportButton
                label="Stock Book Detail For SB"
                icon={CgArrowTopRightR}
                onClick={handleStockBookDetailReportSB}
              />
            </Box>
          </form>
        </Paper>
      </div>
    </>
  );
};

export default StockBookDetail;
